import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-eb24a0bc"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "dialog-container"
};
var _hoisted_2 = {
  class: "iframe-container"
};
var _hoisted_3 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_a_modal = _resolveComponent("a-modal");
  return _openBlock(), _createBlock(_component_a_modal, {
    width: 558,
    footer: null,
    header: null,
    "mask-closable": false,
    "wrap-className": "work-detail-dialog-wrapper",
    visible: _ctx.creation.visible,
    "onUpdate:visible": _cache[0] || (_cache[0] = function ($event) {
      return _ctx.creation.visible = $event;
    })
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_ctx.creation.visible && _ctx.iframeUrl ? (_openBlock(), _createElementBlock("iframe", {
        key: 0,
        width: "100%",
        height: "100%",
        frameborder: "no",
        scrolling: "no",
        src: _ctx.iframeUrl
      }, null, 8, _hoisted_3)) : _createCommentVNode("", true)])])];
    }),
    _: 1
  }, 8, ["visible"]);
}